document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.video-banner-section');
  if (!section) return;
  var wrapper = section.querySelector('.video-banner');
  var video = wrapper.querySelector('.video-banner__video');
  var isIframe = video && video.tagName === 'IFRAME';
  var overlay = wrapper.querySelector('.video-banner__overlay');
  var bannerWrapper = wrapper.querySelector('.video-banner__banner-wrapper');

  function hideBanner() {
    bannerWrapper.classList.add('video-banner__hidden');
    bannerWrapper.classList.remove('video-banner__shown');
    if (overlay) overlay.classList.add('video-banner__overlay--shown');
    if (video) {
      if (isIframe) {
        if (video.classList.contains('js-youtube')) {
          video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":[]}', '*');
        } else if (video.classList.contains('js-vimeo')) {
          video.contentWindow.postMessage({ method: 'play' }, '*');
        }
      } else {
        video.play();
      }
    }
  }

  function showBanner() {
    bannerWrapper.classList.remove('video-banner__hidden');
    bannerWrapper.classList.add('video-banner__shown');
    if (overlay) overlay.classList.remove('video-banner__overlay--shown');
  }

  if (bannerWrapper) {
    bannerWrapper.addEventListener('click', function (e) {
      if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON') {
        hideBanner();
      }
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      if (video) {
        if (isIframe) {
          if (video.classList.contains('js-youtube')) {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":[]}', '*');
          } else if (video.classList.contains('js-vimeo')) {
            video.contentWindow.postMessage({ method: 'pause' }, '*');
          }
        } else {
          video.pause();
        }
      }
      showBanner();
    });
  }
});
